<div class="row">
  <div class="col-lg-6 policies" *ngFor="let policy of lstPolicyReservationCaseModel">
    <div [ngSwitch]="policy.policyDefinitionId">

      <!-- Start DepositPolicy Type-->
      <div *ngSwitchCase="policyType.DepositPolicy">
        <div class="d-flex">
          <img class="custom-icon DepositPolicy mr-1" src="assets/img/icons/deposit-icon.jpg" />
          <div class="policyType">{{ policyType[policyType.DepositPolicy] | translate }}</div>
        </div>
        <ul class="policyRule">
          <ng-container *ngIf="policy.depositPolicyModel.minRequiredDeposit != null">
            <!-- <li>{{'NoPaymentIsRequired' | translate}}</li> -->
            <li>
              {{ depositPolicyPaymentTypes[policy.depositPolicyModel.depositPolicyPaymentTypes] | translate }}
              / <span class="yellow-text">{{policy.depositPolicyModel.minRequiredDeposit }} % </span>
            </li>
            <!-- <li *ngFor="let policyRule of policy.policyRule">{{policyRule}}</li> -->
          </ng-container>
          <ng-container *ngIf="policy.depositPolicyModel.minRequiredDeposit == null">
            <li>{{ depositPolicyPaymentTypes[policy.depositPolicyModel.depositPolicyPaymentTypes] | translate }}
            </li>
          </ng-container>
        </ul>
      </div>
      <!-- End DepositPolicy Type-->

      <!-- Start EarlyReturnPolicy Type-->
      <div *ngSwitchCase="policyType.EarlyReturnPolicy">
        <div class="d-flex">
          <fa-icon class="custom-icon mr-1" [icon]="faBusinessTime"></fa-icon>
          <div class="policyType">{{ policyType[policyType.EarlyReturnPolicy] | translate }}</div>
        </div>
        <ul class="policyRule">
          <ng-container *ngIf="policy.earlyReturnPolicyModel != null">
            <li>{{appliedChargingRate[policy.earlyReturnPolicyModel.appliedChargingRate] | translate }}</li>

            <ng-container *ngIf="policy.earlyReturnPolicyModel.isApplied">
              <li>{{'RemainingRentalPeriod' | translate}}: <span
                  class="yellow-text">{{policy.earlyReturnPolicyModel.remainingRentalPeriod}}</span></li>
              <li>{{'Charge'| translate}} : <span class="yellow-text">{{policy.earlyReturnPolicyModel.chargePercentage}}
                  {{currency}}</span></li>
            </ng-container>

          </ng-container>
        </ul>
      </div>
      <!-- End EarlyReturnPolicy Type-->

      <!-- Start CancelationPolicy Type-->
      <div *ngSwitchCase="policyType.CancelationPolicy">
        <div class="d-flex">
          <mat-icon class="custom-icon mr-1">cancel</mat-icon>
          <div class="policyType">{{ policyType[policyType.CancelationPolicy] | translate }}</div>
        </div>
        <ul class="policyRule">
          <ng-container *ngIf="policy.cancelationPolicyModel != null">
            <div [ngSwitch]="policy.cancelationPolicyModel.cancelationPolicyChargeTypes">
              <div *ngSwitchCase="cancelationPolicyChargeTypes.ApplyCancelationCharges">


                <li>
                  {{cancelationPolicyChargeTypes[policy.cancelationPolicyModel.cancelationPolicyChargeTypes] |
                  translate}}
                </li>

                <li>{{'CancelationChargePercentage' | translate}} : <span
                    class="yellow-text">{{policy.cancelationPolicyModel.cancelationChargePercentage}} % </span>
                </li>
                <li>{{'CancelationPeriod' | translate}} : <span
                    class="yellow-text">{{policy.cancelationPolicyModel.cancelationPeriod}} {{'Hours' | translate}} </span></li>
              </div>
              <div *ngSwitchCase="cancelationPolicyChargeTypes.FreeCancelation">
                <li>
                  {{cancelationPolicyChargeTypes[policy.cancelationPolicyModel.cancelationPolicyChargeTypes] |
                  translate}}
                </li>
              </div>

            </div>
          </ng-container>
        </ul>
      </div>
      <!-- End CancelationPolicy Type-->

      <!-- Start RentalReplacementPolicy Type-->
      <div *ngSwitchCase="policyType.RentalReplacementPolicy">
        <div class="d-flex">
          <!-- <mat-icon class="custom-icon mr-1" svgIcon='rentalReplacement'></mat-icon> -->
          <span>
            <img placement="bottom" class="custom-icon mr-1" src='/assets/img/icons/rental-replacement.svg' />
          </span>
          <div class="policyType">{{ policyType[policyType.RentalReplacementPolicy] | translate }}</div>
        </div>
        <ul class="policyRule">
          <ng-container *ngIf="policy.rentalReplacementPolicyModel != null">
            <div *ngIf="policy.rentalReplacementPolicyModel.isAllowedReplacement">
              <li>
                {{'AllowReplacement' |translate}}: <span
                  class="yellow-text">{{allowedReplacementTypeID[policy.rentalReplacementPolicyModel.replacementType]|
                  translate}}
                </span>
              </li>
            </div>
            <!-- <li>{{allowedReplacementTypeID[policy.rentalReplacementPolicyModel.appliedChargingRate] | translate}}
            </li> -->
            <li *ngIf="policy.rentalReplacementPolicyModel.appliedChargingRateID == 1">
              {{ "ApplyOldRatesOnNewRentalPeriod" | translate }}
            </li>
            <li *ngIf="policy.rentalReplacementPolicyModel.appliedChargingRateID == 2">
              {{ "ApplyNewRatesBasedOnNewRentalPeriod" | translate }}
            </li>

          </ng-container>
        </ul>
      </div>
      <!-- End RentalReplacementPolicy Type-->

      <!-- Start FuelChargingPolicy Type-->
      <div *ngSwitchCase="policyType.FuelChargingPolicy">
        <div class="d-flex">
          <mat-icon class="custom-icon gas_station mr-1">local_gas_station</mat-icon>
          <div class="policyType">{{policyType[policyType.FuelChargingPolicy] | translate }}</div>
        </div>
        <ul class="policyRule">
          <ng-container *ngIf="policy.fuelChargingPolicyModel != null">
            <div [ngSwitch]="policy.fuelChargingPolicyModel.fuelChargingPolicyTypes">
              <div *ngSwitchCase="fuelChargingPolicyTypes.FreeFuel">
                <li>{{fuelChargingPolicyTypes[policy.fuelChargingPolicyModel.fuelChargingPolicyTypes] | translate}}</li>
              </div>
              <div *ngSwitchCase="fuelChargingPolicyTypes.ApplyCharges">

                <li>{{fuelChargingPolicyTypes[policy.fuelChargingPolicyModel.fuelChargingPolicyTypes] | translate}}
                </li>
                <div *ngIf="policy.fuelChargingPolicyModel.fuelChargesList ">
                  <li *ngFor="let itemfuelCharge of policy.fuelChargingPolicyModel.fuelChargesList">
                    <!--Todo: Here the fule type name is lookup-->
                    {{itemfuelCharge.fuelTypeName }}<span class="yellow-text"> ( {{itemfuelCharge.fuelLevel }} ) /
                      {{itemfuelCharge.fuelCharge }}
                      {{currency}}</span>
                  </li>
                </div>
              </div>
            </div>

          </ng-container>
        </ul>
      </div>
      <!-- End FuelChargingPolicy Type-->

      <!-- Start RentalContractTerminationPeriodPolicy Type-->
      <div *ngSwitchCase="policyType.RentalContractTerminationPeriodPolicy">
        <div class="d-flex">
          <!-- <mat-icon class="custom-icon mr-1" svgIcon="rentalContractTermination"></mat-icon> -->
          <span>
            <img placement="bottom" class="custom-icon mr-1" src='/assets/img/icons/rental-contract-termination.svg' />
          </span>
          <div class="policyType">{{ policyType[policyType.RentalContractTerminationPeriodPolicy] | translate }}
          </div>
        </div>
        <ul class="policyRule">
          <ng-container *ngIf="policy.rentalContractTerminationPeriodPolicyModel != null">
            <li>
              {{rentalContractTerminationPeriodTypes[policy.rentalContractTerminationPeriodPolicyModel.rentalContractTerminationPeriodType]
              | translate}}
            </li>

          </ng-container>
        </ul>
      </div>
      <!-- End RentalContractTerminationPeriodPolicy Type-->

      <!-- Start ExceededDistancePolicy Type-->
      <div *ngSwitchCase="policyType.ExceededDistancePolicy">
        <div class="d-flex">
          <fa-icon class="custom-icon mr-1" [icon]="faRoad"></fa-icon>
          <div class="policyType">{{ policyType[policyType.ExceededDistancePolicy] | translate }}</div>
        </div>
        <ul class="policyRule">
          <ng-container *ngIf="policy.exceededDistancePolicyModel != null">
            <div [ngSwitch]="policy.exceededDistancePolicyModel.exceededDistancePolicyTypes">

              <div *ngSwitchCase="exceededDistancePolicyTypes.FreeDistance">
                <li>
                  {{exceededDistancePolicyTypes[policy.exceededDistancePolicyModel.exceededDistancePolicyTypes] |
                  translate}}
                </li>
              </div>
              <div *ngSwitchCase="exceededDistancePolicyTypes.ApplyChargesOnExceededDistance">

                <li>
                  {{exceededDistancePolicyTypes[policy.exceededDistancePolicyModel.exceededDistancePolicyTypes] |
                  translate}}
                </li>
                <li>{{'AllowedDistancePerRentalDay' | translate}} :<span class="yellow-text">
                    {{policy.exceededDistancePolicyModel.allowedDistancePerRentalDay}} </span></li>
                <li>{{'Charge' | translate}} : <span class="yellow-text">{{policy.exceededDistancePolicyModel.charge}} /
                    {{currency}} </span></li>

              </div>
              {{'AllowedDistancePerRentalDay'| translate}} : {{policy.exceededDistancePolicyModel.allowedDistancePerRentalDay }} {{policy.exceededDistancePolicyModel.distanceUnit}}
            </div>
          </ng-container>
        </ul>
      </div>
      <!-- End ExceededDistancePolicy Type-->


      <!-- Start RentalContractExtensionPolicy Type-->
      <div *ngSwitchCase="policyType.RentalContractExtensionPolicy">
        <div class="d-flex">
          <!-- <mat-icon class="custom-icon mr-1" svgIcon="rentalContractExtension"></mat-icon> -->
          <span>
            <img placement="bottom" class="custom-icon mr-1" src='/assets/img/icons/rental-contract-extension.svg' />
          </span>
          <div class="policyType">{{ policyType[policyType.RentalContractExtensionPolicy] | translate }}</div>
        </div>
        <ul class="policyRule">
          <ng-container *ngIf="policy.rentalContractExtensionPolicyModel != null">
            <li>{{extensionRules[policy.rentalContractExtensionPolicyModel.extensionRules]| translate}}</li>
            <li>
              {{appliedChargingRateOnExtendedPeriod[policy.rentalContractExtensionPolicyModel.appliedChargingRateOnExtendedPeriod] | translate}}
            </li>
          </ng-container>
        </ul>
      </div>
      <!-- End RentalContractExtensionPolicy Type-->

      <!-- Start LateReturnWithNoShowPolicy Type-->
      <div *ngSwitchCase="policyType.LateReturnWithNoShowPolicy">
        <div class="d-flex">
          <!-- <mat-icon class="custom-icon mr-1" svgIcon="lateReturn"></mat-icon> -->
          <span>
            <img placement="bottom" class="custom-icon mr-1" src='/assets/img/icons/late-return.svg' />
          </span>
          <div class="policyType">{{ policyType[policyType.LateReturnWithNoShowPolicy] | translate }}</div>
        </div>
        <ul class="policyRule">
          <ng-container *ngIf="policy.lateReturnWithNoShowPolicyModel != null">
            <li>{{appliedChargingRate[policy.lateReturnWithNoShowPolicyModel.appliedChargingRate] | translate}}</li>
            <div *ngIf="policy.lateReturnWithNoShowPolicyModel.isApplied">
              <li>{{'Charge' | translate}} : <span
                  class="yellow-text">{{policy.lateReturnWithNoShowPolicyModel.charage}} {{currency}}</span></li>
            </div>
          </ng-container>
        </ul>
      </div>
      <!-- End LateReturnWithNoShowPolicy Type-->

      <!-- Start AgeRestrictionPolicy Type-->
      <div *ngSwitchCase="policyType.AgeRestrictionPolicy">
        <div class="d-flex">
          <fa-icon class="custom-icon mr-1" [icon]="faCalendarAlt"></fa-icon>
          <div class="policyType">{{ policyType[policyType.AgeRestrictionPolicy] | translate }}</div>
        </div>
        <ul class="policyRule">
          <ng-container *ngIf="policy.ageRestrictionPolicyModel != null">
            <div [ngSwitch]="policy.ageRestrictionPolicyModel.ageRestrictionType">
              <div *ngSwitchCase="ageRestrictionPolicyTypes.NoAgeRestrictions">
                <li>{{ageRestrictionPolicyTypes[policy.ageRestrictionPolicyModel.ageRestrictionType] | translate}}
                </li>
              </div>
              <div *ngSwitchCase="ageRestrictionPolicyTypes.ApplyChargesForSpecificAgeRangeAsARiskFactor">
                <!-- <li>{{'NoAgeRestrictions' | translate}}</li> -->
                <li>{{ageRestrictionPolicyTypes[policy.ageRestrictionPolicyModel.ageRestrictionType] | translate}}
                </li>
                <div *ngIf="policy.ageRestrictionPolicyModel.ageChargesList != null">
                  <div *ngFor="let itemAgeCharges of policy.ageRestrictionPolicyModel.ageChargesList">
                    <li>{{'AgeFrom' | translate}} <span class="yellow-text">:
                        {{itemAgeCharges.ageFrom}}</span>,{{'AgeTo' | translate}} :<span class="yellow-text">
                        {{itemAgeCharges.ageTo}}</span> ,{{'Charge' | translate}}:
                      <span class="yellow-text"> {{itemAgeCharges.chargePercentage}} {{currency}}</span>
                    </li>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

        </ul>
      </div>
      <!-- End AgeRestrictionPolicy Type-->


      <!-- Start UnavailableBookedVehicleHandlingPolicy Type-->
      <div *ngSwitchCase="policyType.UnavailableBookedVehicleHandlingPolicy">
        <div class="d-flex">
          <mat-icon>warning</mat-icon>
          <div class="policyType">{{ policyType[policyType.UnavailableBookedVehicleHandlingPolicy] | translate }}
          </div>
        </div>
        <ul class="policyRule">
          <ng-container *ngIf="policy.unavailableBookedVehicleHandlingPolicyModel != null">
            <li>
              {{appliedRateTypeID[policy.unavailableBookedVehicleHandlingPolicyModel.appliedRateType] | translate}}
            </li>
            <div *ngIf="policy.unavailableBookedVehicleHandlingPolicyModel.isAllowedToCompensate">
              <li>{{'Allowtocompensatefromanyotherclassesifsameclassisnotavailable' | translate}}</li>
            </div>
            <li>{{'Excesswillbecharged' | translate}}</li>
          </ng-container>
        </ul>
      </div>
      <!-- End UnavailableBookedVehicleHandlingPolicy Type-->

      <!-- Start SecurityDepositPolicy Type-->
      <div *ngSwitchCase="policyType.SecurityDepositPolicy">
        <div class="d-flex">
          <img class="custom-icon DepositPolicy mr-1" src="assets/img/icons/deposit-icon.jpg" />
          <div class="policyType">
            {{ policyType[policyType.SecurityDepositPolicy] | translate }}</div>
        </div>
        <ul class="policyRule">
          <ng-container *ngIf="policy.securityDepisitPolicyModel != null">
            <li>{{securityDepositType[policy.securityDepisitPolicyModel.securityDepositType] | translate}}</li>
            <div *ngIf="policy.securityDepisitPolicyModel.amountType==amountPolicyTypes.Fixed">
              <li>{{amountPolicyTypes[policy.securityDepisitPolicyModel.amountType] | translate}} : <span
                  class="yellow-text"> {{policy.securityDepisitPolicyModel.depositValue}} {{currency}}</span></li>
            </div>

            <div *ngIf="policy.securityDepisitPolicyModel.amountType==amountPolicyTypes.Percentage">
              <li>{{amountPolicyTypes[policy.securityDepisitPolicyModel.amountType] | translate}} : <span
                  class="yellow-text"> {{policy.securityDepisitPolicyModel.depositValue}} %</span></li>
             <li>{{policy.securityDepisitPolicyModel.depositMinValue | number : '1.2-2' }} {{currency}}</li>
            </div>

          </ng-container>
        </ul>
      </div>
      <!-- End SecurityDepositPolicy Type-->

    </div>
  </div>
</div>
